export default "__VITE_ASSET__BokTDMUo__"